import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import * as NotificationsActions from '../notifications/notifications.actions';
import { Notification, NotificationLevel } from 'src/app/model/notification';
import * as DeviceListActions from './device-list.actions';
import { DeviceService } from 'src/app/services/device.service';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class DeviceListEffects {
    getInstalledViews$ = createEffect(() => this.actions$.pipe(
        ofType(DeviceListActions.getInstalledViews),
        switchMap((action) => this.deviceService.getInstalledViews(action.paging, action.filter, null, action.siteId).pipe(
            map((resp) => {
                if (resp.Success) {
                    return DeviceListActions.getInstalledViewsSuccess({ paging: resp.Data.Paging, installedViews: resp.Data.Items });
                } else {
                    return DeviceListActions.getInstalledViewsFailed({ errorMessage: resp.ErrorMessage });
                }
            }),
            catchError(error => {
                console.error(error);
                return of(DeviceListActions.getInstalledViewsFailed({ errorMessage: error.message }));
            })
        ))
    ));

    getNotificationView$ = createEffect(() => this.actions$.pipe(
        ofType(DeviceListActions.getNotificationView),
        switchMap((action) => this.deviceService.getNotificationView(action.paging, action.filter, action.acls).pipe(
            map((resp) => {
                if (resp.Success) {
                    return DeviceListActions.getNotificationViewSuccess({ paging: resp.Data.Paging, notificationView: resp.Data.Items });
                } else {
                    return DeviceListActions.getNotificationViewFailed({ errorMessage: resp.ErrorMessage });
                }
            }),
            catchError(error => {
                console.error(error);
                return of(DeviceListActions.getNotificationViewFailed({ errorMessage: error.message }));
            })
        ))
    ));

    // notifySuccess$ = createEffect(() => this.actions$.pipe(
    //     ofType(
    //         DeviceListActions.getNotificationViewSuccess,
    //     ),
    //     tap((action) => {
    //         const notification = new Notification("DEVICE", "Success", NotificationLevel.Success, '');
    //         this.store.dispatch(NotificationsActions.addNotification({ notification: notification, toastOnly: true }));
    //     })
    // ), { dispatch: false });

    notifyError$ = createEffect(() => this.actions$.pipe(
        ofType(
            DeviceListActions.getInstalledViewsFailed,
            DeviceListActions.getNotificationViewFailed,
        ),
        tap((action) => {
            if (action.errorMessage === '') {
                return;
            }
            const notification = new Notification("DEVICE-LIST", action.errorMessage, NotificationLevel.Error, '');
            this.store.dispatch(NotificationsActions.addNotification({ notification: notification, toastOnly: true }));
        })
    ), { dispatch: false });

    constructor(
        private actions$: Actions,
        private deviceService: DeviceService,
        private translate: TranslateService,
        private store: Store<AppState>,
    ) {}
}

